export default "__VITE_ASSET__BfgfkfmG__";